// Text field with a contact string and a "copy" button with visual feedback.

import { IconButton, Paper, Divider } from "@mui/material";
import { useState } from "react";
import { useTheme } from "@emotion/react";

export default function CopyContact({ contact }) {
  const theme = useTheme();

  const [emailShown, setEmailShown] = useState(true);

  async function copyValue() {
    navigator.clipboard.writeText(contact);
    setEmailShown(false);
    await new Promise((res) => setTimeout(res, 2500));
    setEmailShown(true);
  }

  return (
    <>
      <Paper
        component="form"
        variant="outlined"
        square={false}
        sx={{
          display: "flex",
          alignItems: "center",
          width: 400,
          borderColor: "paperBorder.main",
        }}
      >
        <span
          style={{
            flexGrow: 1,
            textAlign: "center",
            fontSize: "1.5rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {emailShown ? (
            contact
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill={theme.palette.primary.main}
              >
                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
              </svg>
              Copied!
            </>
          )}
        </span>
        <Divider
          sx={{ height: 50, borderColor: "paperBorder.main" }}
          orientation="vertical"
        />
        <IconButton
          type="button"
          aria-label="copy email address"
          onClick={copyValue}
          sx={{ width: 50, height: 50, color: "primary.main" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
          >
            <path
              d="M760-200H320q-33 0-56.5-23.5T240-280v-560q0-33 23.5-56.5T320-920h280l240 240v400q0 33-23.5 56.5T760-200ZM560-640v-200H320v560h440v-360H560ZM160-40q-33 0-56.5-23.5T80-120v-560h80v560h440v80H160Zm160-800v200-200 560-560Z"
              fill={theme.palette.primary.main}
            />
          </svg>
        </IconButton>
      </Paper>
    </>
  );
}
